// extracted by mini-css-extract-plugin
export default {"banner":"k6sT_k","title":"rn3tMX","caption":"br5gIM","download":"vVd3qE","qrCode":"M3YkpB","storeList":"eGJb2W","imageColumn":"d0EGsT","imageColumnPositionBottom":"S1PFg0"};